<div *ngIf="attendanceReports.length > 0" class="report-list">
  <div class="overflow-x-auto">
    <div class="table-shell">
      <table class="report-table">
        <colgroup>
          <col class="report-table__col report-table__col--user" />
          <col class="report-table__col report-table__col--contact" />
          <col class="report-table__col report-table__col--protocols" />
          <col class="report-table__col report-table__col--reason" />
          <col class="report-table__col report-table__col--queue" />
          <col class="report-table__col report-table__col--attendance" />
          <col class="report-table__col report-table__col--evaluation" />
        </colgroup>

        <thead class="border-b border-gray-400">
          <tr>
            <th scope="col">Usuário</th>
            <th scope="col">Contato</th>
            <th scope="col">Protocolos</th>
            <th scope="col">Motivo</th>
            <th scope="col">Empresa / Fila</th>
            <th scope="col">Atendimento</th>
            <th scope="col">Avaliação</th>
            <th
              scope="col"
              class="report-table__heading--actions"
              *isAllowed="[ERoleAdminString.Admin, 'reports.edit']"
            >
              Mais info
            </th>
          </tr>
        </thead>

        <tbody>
          <tr class="report-table__row" *ngFor="let report of attendanceReports">
            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.userName || '-'">
                  {{ report.userName || '-' }}
                </span>
                <span
                  class="cell-secondary cell-ellipsis"
                  [title]="report.cpf ? (report.cpf | maskSensitiveInfo) : '-'"
                >
                  CPF: {{ report.cpf ? (report.cpf | maskSensitiveInfo) : '-' }}
                </span>
              </div>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.email ? (report.email | maskSensitiveInfo) : '-'">
                  {{ report.email ? (report.email | maskSensitiveInfo) : '-' }}
                </span>
                <span
                  class="cell-secondary cell-ellipsis"
                  [title]="report.phone ? (report.phone | maskSensitiveInfo) : '-'"
                >
                  Telefone: {{ report.phone ? (report.phone | maskSensitiveInfo) : '-' }}
                </span>
              </div>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.externalProtocol || '-'">
                  Externo: {{ report.externalProtocol || '-' }}
                </span>
                <span class="cell-secondary cell-ellipsis" [title]="report.protocolNumber || '-'">
                  Interno: {{ report.protocolNumber || '-' }}
                </span>
              </div>
            </td>

            <td>
              <span class="cell-main cell-ellipsis" [title]="report.reason || '-'">
                {{ report.reason || '-' }}
              </span>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.companyName || '-'">
                  {{ report.companyName || '-' }}
                </span>
                <span class="cell-secondary cell-ellipsis" [title]="report.queueName || '-'">
                  Fila: {{ report.queueName || '-' }}
                </span>
              </div>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-badge cell-ellipsis" [title]="report.status || 'Sem status'">
                  {{ report.status || 'Sem status' }}
                </span>
                <span
                  class="cell-secondary cell-ellipsis"
                  [title]="
                    hasQueueEntryTime(report)
                      ? (toUtcDate(report.queueEntryTime) | date: 'dd/MM/yyyy HH:mm' : BRAZIL_TIMEZONE_OFFSET)
                      : 'Sem data'
                  "
                >
                  Entrada:
                  {{
                    hasQueueEntryTime(report)
                      ? (toUtcDate(report.queueEntryTime) | date: 'dd/MM/yyyy HH:mm' : BRAZIL_TIMEZONE_OFFSET)
                      : 'Sem data'
                  }}
                </span>
                <span
                  *ngIf="report.startTime"
                  class="cell-secondary cell-ellipsis"
                  [title]="toUtcDate(report.startTime) | date: 'dd/MM/yyyy HH:mm' : BRAZIL_TIMEZONE_OFFSET"
                >
                  Atendimento: {{ toUtcDate(report.startTime) | date: 'dd/MM/yyyy HH:mm' : BRAZIL_TIMEZONE_OFFSET }}
                </span>
              </div>
            </td>

            <td>
              <button
                *ngIf="report.evaluationAnswers"
                class="report-table__action-button"
                (click)="openEvaluationModal(report)"
                title="Ver avaliação de atendimento"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#4caf50"
                  width="20"
                  height="20"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </button>
              <span *ngIf="!report.evaluationAnswers" class="cell-secondary">—</span>
            </td>

            <td class="report-table__actions" *isAllowed="[ERoleAdminString.Admin, 'reports.edit']">
              <button
                *isAllowed="[ERoleAdminString.Admin, 'reports.edit']"
                class="report-table__action-button"
                [routerLink]="'editar/' + report.id"
                title="Editar relatório"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#000000"
                  width="20"
                  height="20"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-no-results-found [condition]="attendanceReports.length === 0"></app-no-results-found>

<div class="pagination-wrapper">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
